import { appViewState } from "sh-application/store";
import { GlobalCommandBarTab } from "../schema/GlobalCommandBarViewState";
import { mutatorAction } from "satcheljs";

export default mutatorAction("SET_SELECTED_TAB",
    function setGlobalCommandBarSelectedTab(tab: GlobalCommandBarTab) {
        appViewState().globalCommandBarViewState.selectedTab = tab;
    });